export default __webpack_public_path__ + "static/media/icon_all.fa88175b.svg";